import { ApiCreateWillParticipantDto } from '@/shared/api/generated/data-contracts';
import { useApi } from '@/shared/api/hooks/useApi';

import { useInterwillsActions } from './useInterwillActions';
import { useRemoveParticipantRole } from './useRemoveParticipantRole';

export const useAddParticipantRole = () => {
  const api = useApi();
  const actions = useInterwillsActions();
  const removeRole = useRemoveParticipantRole();

  return async (
    centralDbProfileId: number | undefined,
    role: ApiCreateWillParticipantDto['role'],
  ) => {
    const resWill = await actions.getInterwill();

    if (resWill?.centralDbInterwillId && centralDbProfileId) {
      await removeRole(centralDbProfileId);

      return await api.willsCreateParticipant(resWill.centralDbInterwillId, {
        profileId: centralDbProfileId,
        role,
      });
    }

    return null;
  };
};
